<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;

}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/supplier/asn/page" getKey="rows"
                   :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('asndanhao')">
            <el-input v-model="yt.conditions.asnNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')">
            <yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'"
                             :ids.sync="yt.conditions.supplierIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select :type="'ASN_ORDER_STATUS'" :ids.sync="yt.conditions.orderStatus">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <!--      <template #buttonsL>-->
      <!--        <el-button size="mini" v-if="utils.checkPower('web_purchasing_management_purchase_order_create')"-->
      <!--                   @click="yt.showEditDialog('xinzeng',null,'80%',beforeShowEditDialog);getSupplierList();getCustomer();setDefaultValue();"-->
      <!--                   type="primary">-->
      <!--          {{$t('xinzeng')}}-->
      <!--        </el-button>-->
      <!--      </template>-->
      <template #danjudalei="scope">
        {{
          $t(store.state.dictJsonAll["DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE"][scope.row.documentTypeConfiguration.categories])
        }}
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="scope.row.reviewStatus === '1'" type="text"
                       @click="yt.showEditDialog('bianji', scope.row,'80%',beforeEdit);getSupplierList();getDocumentList()">
              {{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-popconfirm :title="$t('quedingshenheshuju')" :confirm-button-text="$t('queding')"
                           @confirm="process(scope.row)">
              <el-button v-if="scope.row.reviewStatus === '1'" type="text" slot="reference"
                         :loading="scope.row.processLoading">{{$t('shenhe')}}
              </el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chakan', scope.row,'80%',beforeEdit)"
                       v-if="scope.row.reviewStatus==='2'&&(scope.row.orderStatus === '2'||scope.row.orderStatus === '3'||scope.row.orderStatus === '4')">
              {{$t('chakan')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text"
                       v-if="scope.row.orderStatus === '2'||scope.row.orderStatus === '3'||scope.row.orderStatus === '4'">
              {{$t('dayin')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fahuoqueren', scope.row,'w1')"
                       v-if="scope.row.orderStatus === '2'">
              {{$t('fahuoqueren')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="reject(scope.row)" class="font-color-danger"
                       v-if="scope.row.orderStatus==='2'">
              {{$t('shenhebohui')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.reviewStatus === '1'" type="text" class="font-color-danger"
                       @click="yt.remove(scope.row,'/web/supplier/asn/delete')">
              {{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body"
               :destroy-on-close="true">
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        {{
          $nextTick(() => {
            $refs.yt2.list = editList
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{$t('rukudantouxinxi')}}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth"
                     style="margin-left: 100px">
              <el-form-item :label="$t('danjudalei')" required>
                <!--                $t(store.state.dictJsonAll["DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE"][scope.row.documentTypeConfiguration.categories])-->
                <span
                    style="margin-left: 15px">{{$t(store.state.dictJsonAll['DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE'][yt.editObj.documentTypeConfiguration.categories])}}</span>
              </el-form-item>
              <el-form-item :label="$t('danjuxiaolei')" required class="noborder">
<!--                <el-input v-model="yt.editObj.documentTypeConfiguration.smallName" disabled></el-input>-->
                <el-select :clearable="true" v-model="yt.editObj.documentTypeConfigurationId" collapse-tags :placeholder="$t('qingxuanze')">
                  <el-option v-for="(category, index) in docCategories" :key="category.id" :label="category.smallName" :value="category.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangmingcheng')" required class="noborder">
                <!--                <yi_cross_select :max="1" :component="'web_wms_purchase_receipt_supplier_information'"-->
                <!--                                 :ids.sync="yt.editObj.supplierId"></yi_cross_select>-->
                <el-select collapse-tags v-model="yt.editObj.supplierId" filterable disabled>
                  <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required>
                <el-input v-model="yt.editObj.supplier.address"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required>
                <el-input v-model="yt.editObj.receiptAddress"></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{$t('rukudanmingxixinxi')}}
          </div>
          <div style="flex:1;">
            <yi_curd_table v-bind="$attrs" :name="$options.name+'2'" ref="yt2" :isRandKey="false"
                           :columns="columnsItem">
              <template #buttonsL="scope">
                <el-button size="mini" @click="addEditTable(scope._index, $event)" type="primary">
                  {{$t('xinzeng')}}
                </el-button>
                <!--                <el-button size="mini" @click="isShowUploadDialog=true" plain>-->
                <!--                  {{$t('daoru')}}-->
                <!--                </el-button>-->
              </template>
              <!--              <template #rukudingdanhanghao="scope">-->
              <!--                <el-input class="inputClass" v-model="scope.row.no"></el-input>-->
              <!--              </template>-->
              <template #caigoudingdanhao="scope">
                <yi_cross_select :key="scope._index" :selectTitle="'purchaserOrder.no'"  class="inputClass" :max="1"
                                 :component="'web_supplier_portal_purchase_order_accept_list'"
                                 :ids.sync="scope.row.purchaseOrderDetailId"
                                 @getItems="(item) => {getPurchaseOrder(scope._index, item);}"></yi_cross_select>
              </template>
              <template #caigoudingdanhanghao="scope">
                <el-input class="inputClass" v-model="scope.row.no"></el-input>
<!--                <yi_cross_select :key="scope._index" :selectTitle="'no'" class="inputClass" :max="1"-->
<!--                                 :component="'web_supplier_portal_purchase_order_accept_list'"-->
<!--                                 :ids.sync="scope.row.purchaseOrderDetailId"></yi_cross_select>-->
              </template>
              <template #wuliaobianmamingcheng="scope">
                <el-input class="inputClass" v-model="scope.row.codeName" disabled></el-input>

              </template>
              <template #dingdanshuliang="scope">
                <el-input class="inputClass" v-model="scope.row.quantity" disabled></el-input>
              </template>
              <template #caigoudanwei="scope">
                <el-input class="inputClass" v-model="scope.row.unit" disabled></el-input>
              </template>
              <template #bencisonghuoshuliang="scope">
                <el-input-number class="inputClass" :precision="5"  v-model="scope.row.deliveryQuantity"
                                 :controls="false"></el-input-number>
              </template>
              <template #shishoushuliang="scope">
                <!--                                <el-input class="inputClass" v-model="scope.row.tolerance"></el-input>-->
                <el-input-number class="inputClass" :precision="1" :min="0" v-model="scope.row.receiveQuantity"
                                 :controls="false"></el-input-number>
              </template>
              <template #shengchanriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date"
                               :time.sync="scope.row.productionDate">
                </yi_time_input>
              </template>
              <template #shixiaoriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date"
                               :time.sync="scope.row.expirationDate">
                </yi_time_input>
              </template>
              <template #shouhuoriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date"
                               :time.sync="scope.row.receiptDate">
                </yi_time_input>
              </template>
              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger"
                               @click="removeEdit(scope._index, $event)">
                      {{$t('shanchu')}}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>

          </div>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          	<el-button size="mini" :loading="yt.editObj.loading"
                       @click="yt.req('POST','/web/supplier/asn/update', beforeEditAdd)"
                       type="primary">
						{{$t('baocun')}}
					</el-button>
<!--          	<el-button size="mini" :loading="yt.editObj.loading"-->
<!--                       @click="addSave"-->
<!--                       type="primary">-->
<!--						{{$t('baocun')}}-->
<!--					</el-button>-->
				</span>
      </template>
      <!--查看-->
      <template v-if="yt.editObj.action == 'chakan'">
        {{
          $nextTick(() => {
            $refs.yt2.list = editList
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{$t('caigoudingdantouxinxi')}}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth"
                     style="margin-left: 100px">
              <el-form-item :label="$t('danjudalei')" required>
                <span
                    style="margin-left: 15px">{{$t(store.state.dictJsonAll['DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE'][yt.editObj.documentTypeConfiguration.categories])}}</span>
              </el-form-item>
              <el-form-item :label="$t('danjuxiaolei')" required class="noborder">
                <el-input v-model="yt.editObj.documentTypeConfiguration.smallName" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangmingcheng')" required class="noborder">
                <el-select collapse-tags v-model="yt.editObj.supplierId" filterable disabled>
                  <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required class="noborder">
                <el-input v-model="yt.editObj.supplier.address" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required class="noborder">
                <el-input v-model="yt.editObj.receiptAddress" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')" class="noborder">
                <el-input v-model="yt.editObj.remark" disabled></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{$t('caigoudingdanmingxixinxi')}}
          </div>
          <div style="flex:1;">
            <yi_curd_table v-bind="$attrs" :name="$options.name+'2'" ref="yt2"
                           :columns="checkItem">
<!--              <template #bencisonghuoshuliang="scope">-->
<!--                <el-input-number class="inputClass" :precision="5" v-model="scope.row.deliveryQuantity" disabled-->
<!--                                 :controls="false"></el-input-number>-->
<!--              </template>-->
              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" @click="printLabel(scope.row)">
                      {{$t('dayinbiaoqian')}}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
      </template>
      <!--发货确认-->
      <template v-if="yt.editObj.action == 'fahuoqueren'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('asndanhao')" required class="noborder">
              <el-input v-model="yt.editObj.asnNo" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('gongyingshangbianma')" required class="noborder">
              <el-input v-model="yt.editObj.supplier.code" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('gongyingshangmingcheng')" required class="noborder">
              <el-input v-model="yt.editObj.supplier.name" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('shouhuodizhi')" required class="noborder">
              <el-input v-model="yt.editObj.receiptAddress" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('songhuochepaihao')">
              <el-input v-model="yt.editObj.deliveryLicensePlateNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sijidianhua')">
              <el-input v-model="yt.editObj.driverPhone"></el-input>
            </el-form-item>
            <el-form-item :label="$t('wuliugongsi')">
              <el-input v-model="yt.editObj.logisticsCompany"></el-input>
            </el-form-item>
            <el-form-item :label="$t('wuliudanhao')">
              <el-input v-model="yt.editObj.logisticsNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yujidaohuoriqi')" required>
              <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date"
                             :time.sync="yt.editObj.expectArrivalDate">
              </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
                     @click="yt.req('POST','/web/supplier/asn/shipping/confirm')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
    </el-dialog>

  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_supplier_portal_asn_list',
  data() {
    return {
      editList: [],
      supplierList: [],
      docCategories: [],
      columns: [{
        label: 'asndanhao',
        prop: 'asnNo',
        width: 130
      }, {
        label: 'danjudalei',
        prop: 'documentTypeConfiguration.categories',
        type: 'slot',
        width: 130
      },
        {
          label: 'danjuxiaolei',
          prop: 'documentTypeConfiguration.smallName',
          width: 130
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name',
          width: 130
        },
        {
          label: 'gongyingshangdizhi',
          prop: 'supplier.address',
          width: 130
        },
        {
          label: 'shouhuodizhi',
          prop: 'receiptAddress',
          width: 130,
        },
        {
          label: 'fahuoriqi',
          prop: 'shipDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 150
        },
        {
          label: 'yujidaohuoshijian',
          prop: 'expectArrivalDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 130
        },
        {
          label: 'shouhuoriqi',
          prop: 'receiptDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 130
        }, {
          label: 'songhuochepaihao',
          prop: 'deliveryLicensePlateNo',
          width: 130
        }, {
          label: 'sijidianhua',
          prop: 'driverPhone',
          width: 130
        }, {
          label: 'wuliugongsi',
          prop: 'logisticsCompany',
          width: 130
        }, {
          label: 'wuliudanhao',
          prop: 'logisticsNo',
          width: 130
        },
        {
          label: 'shenhezhuangtai',
          prop: 'reviewStatus',
          type: "dictionary_tag",
          key: "ASN_REVIEW_STATUS",
        }, {
          label: 'danjuzhuangtai',
          prop: 'orderStatus',
          type: "dictionary_tag",
          key: "ASN_ORDER_STATUS",
        }, {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130
        }, {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          // format: 'YYYY-MM-DD HH:mm:ss',
          width: 180
        }, {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }],
      //编辑
      columnsItem: [
        {
        label: 'caigoudingdanhao',
        prop: 'status',
        type: 'slot',
        wrap: true,
        isStar: true,
        width: 130
      }, {
        label: 'caigoudingdanhanghao',
        prop: 'status',
        type: 'slot',
        wrap: true,
        width: 130
      }, {
        label: 'wuliaobianmamingcheng',
        prop: 'materialId',
        type: 'slot',
        wrap: true,
        isStar: true,
        width: 130
      }, {
        label: 'dingdanshuliang',
        prop: 'quantity',
        type: 'slot',
        wrap: true,
        isStar: true,
        width: 130
      }, {
        label: 'caigoudanwei',
        prop: 'defaultUnit',
        type: 'slot',
        wrap: true,
        isStar: true,
        // width: 130
      }, {
        label: 'bencisonghuoshuliang',
        prop: 'deliveryTime',
        width: 160,
        type: 'slot',
        wrap: true,
        isStar: true,
        // width: 130
      }, {
        label: 'shishoushuliang',
        prop: 'tolerance',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'shengchanriqi',
        prop: 'productionDate',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'shixiaoriqi',
        prop: 'expirationDate',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'shouhuoriqi',
        prop: 'receiptDate',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 100,
        wrap: true,
        fixed: 'right'
      }],
      //  查看列
      checkItem: [{
        label: 'mingxizhuangtai',
        prop: 'detailStatus',
        width: 160,
        type: 'dictionary_tag',
        key: "ASN_DETAIL_STATUS",
      },  {
        label: 'caigoudingdanhao',
        prop: 'purchaseOrder.no',
        width: 130
      }, {
        label: 'caigoudingdanhanghao',
        prop: 'purchaseOrderDetail.no',
        width: 130
      }, {
        label: 'wuliaobianmamingcheng',
        prop: 'purchaseOrderDetail.material.name',
        width: 130
      }, {
        label: 'wuliaopicihao',
        prop: 'materialBatchNo',
        width: 130
      }, {
        label: 'dingdanshuliang',
        prop: 'purchaseOrderDetail.quantity',
        width: 130
      }, {
        label: 'caigoudanwei',
        prop: 'purchaseOrderDetail.unit',
      }, {
        label: 'bencisonghuoshuliang',
        prop: 'deliveryQuantity',
        // type: 'slot',
        wrap: true,
        width: 160,
      }, {
        label: 'yishoushuliang',
        prop: 'receiveQuantity',
        width: 160
      }, {
        label: 'weishoushuliang',
        prop: 'unreceiveQuantity',
        width: 160
      }, {
        label: 'shouhuokuwei',
        prop: 'receiveLocationName',
        width: 160
      }, {
        label: 'yishangjiashuliang',
        prop: 'listedQuantity',
        width: 160
      }, {
        label: 'weishangjiashuliang',
        prop: 'unlistedQuantity',
        width: 160
      }, {
        label: 'shangjiakuwei',
        prop: 'listedLocationName',
        width: 160
      }, {
        label: 'jianyanjieguo',
        prop: 'iqc.inspectionResult',
        type: "dictionary_tag",
        key: "TEST_RESULTS",
        wrap: true,
      }, {
        label: 'pandingjieguo',
        prop: 'iqc.judgmentResult',
        width: 150,
        type: "dictionary_tag",
        key: "JUDGMENT_RESULTS",
        wrap: true,
      }, {
        label: 'tuihuoshuliang',
        prop: 'returnQuantity',
        width: 160
      }, {
        label: 'shengchanriqi',
        prop: 'productionDate',
        type: 'time',
        format: 'YYYY-MM-DD',
        width: 160
      }, {
        label: 'shixiaoriqi',
        prop: 'expirationDate',
        type: 'time',
        format: 'YYYY-MM-DD',
        width: 160
      }, {
        label: 'shouhuoriqi',
        prop: 'receiptDate',
        type: 'time',
        format: 'YYYY-MM-DD',
        width: 160
      }, {
        label: 'beizhu',
        prop: 'remark',
        width: 160
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 100,
        wrap: true,
        fixed: 'right'
      }],
    }
  },
  created() {
    setTimeout(() => {
      //表格默认按照异常类型编码升序排序。
      // this.yt.conditions = {
      //   orderBy: 'code asc',
      // }
      this.yt.get(1);
    }, 300)
  },
  methods: {
    getDocumentList() {
      this.http
          .get("/web/document/permission/configuration/item/list?type=0&categories=0")
          .then((res) => {
            this.docCategories = res.data;
          })
          .catch((error) => {
            this.utils.errorMessage(this.$t(error));
          });
    },

    beforeEditAdd(params, url){
      return params
    },
    getPurchaseOrder(index, item) {
      this.$set(this.editList[index], 'quantity', item.quantity || '')
      this.$set(this.editList[index], 'unit', item.unit || '')
      this.$set(this.editList[index], 'no', item.no || '')
      this.$set(this.editList[index], 'codeName', item.material.code+'/'+item.material.name || '')
      this.$set(this.editList[index], 'purchaseOrderId', item.purchaserOrderId || '')
    },
    beforeEdit(row) {
      this.editList = row.asnDetailList
      for (let i = 0; i < this.editList.length; i++) {
        this.$set(this.editList[i],'quantity',this.editList[i].purchaseOrderDetail.quantity)
        this.$set(this.editList[i],'unit',this.editList[i].purchaseOrderDetail.unit)
        this.$set(this.editList[i],'no',this.editList[i].purchaseOrderDetail.no)
        this.$set(this.editList[i],'codeName',this.editList[i].purchaseOrderDetail.material.code+'/'+this.editList[i].purchaseOrderDetail.material.name)
      }
      console.log('sssss2222', this.editList)
      return row
    },
    addEditTable(index, item) {
      const newItem = {
        no:'',
        purchaseOrderId: '',
        purchaseOrderDetailId: '',
        codeName: '',
        quantity: '',
        unit: '',
        deliveryQuantity: '',
        receiveQuantity: '',
        productionDate: '',
        expirationDate: '',
        receiptDate: '',
        remark: '',
        order: {},
      }
      this.editList.push(newItem)
    },
    removeEdit(index, item) {
      this.editList.splice(index, 1)
    },
    // 获取供应商编码、名称
    async getSupplierList() {
      return await this.http.get('/web/supplier/page?' + this.qs.stringify({
        pageNum: 1,
        pageSize: 999,
        // orderBy: 'sort',
      })).then(response => {
        this.supplierList = response.data.rows || []
        for (let i = 0; i < this.supplierList.length; i++) {
          const supplierCodeName = this.supplierList[i]['code'] + '/' + this.supplierList[i]['name']
          this.$set(this.supplierList[i], 'supplierCodeName', supplierCodeName)
        }
        console.log('this.supplierList', this.supplierList)
      })
    },
    //审核
    process(row) {
      this.http.post('/web/supplier/asn/review', {
        id: row.id,
        reviewStatus: 2,
      }).then((res) => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch((error) => {
        this.utils.errorMessage(this.$t(error))
      }).finally(() => {
        this.$set(row, "processLoading", false)
      })
    },
    //审核驳回
    reject(row) {
      this.http.post('/web/supplier/asn/review/reject', {
        id: row.id,
        reviewStatus: 1,
      }).then((res) => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch((error) => {
        this.utils.errorMessage(this.$t(error))
      })
    },
    //发货确认
    deliveryConfirm(row) {
      this.http.post('/web/supplier/asn/shipping/confirm', {
        id: row.id,
        reviewStatus: 1,
      }).then((res) => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch((error) => {
        this.utils.errorMessage(this.$t(error))
      })
    },
  }
}
</script>
